export default "__VITE_ASSET__1d8050b8__"